import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { isMobile } from 'is-mobile';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var icon = "data:image/png;base64,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";
var isInstalled = function isInstalled() {
  var _a;
  return !!((_a = window.nearFiWallet) === null || _a === void 0 ? void 0 : _a.isNearFi);
};
var setupNearFiState = function setupNearFiState() {
  var wallet = window.nearFiWallet;
  return {
    wallet: wallet
  };
};
var NearFi = function NearFi(_ref) {
  var options = _ref.options,
    metadata = _ref.metadata,
    store = _ref.store,
    emitter = _ref.emitter,
    logger = _ref.logger;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var _state, signOut, setupEvents, _getAccounts, isValidActions, transformActions, transformTransactions;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _state = setupNearFiState();
          signOut = function signOut() {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var res, error;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (_state.wallet.isSignedIn()) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return");
                  case 2:
                    _context.next = 4;
                    return _state.wallet.signOut();
                  case 4:
                    res = _context.sent;
                    if (!(res === true)) {
                      _context.next = 7;
                      break;
                    }
                    return _context.abrupt("return");
                  case 7:
                    error = new Error(typeof res.error === "string" ? res.error : res.error.type); // Prevent signing out by throwing.
                    if (!(error.message === "User reject")) {
                      _context.next = 10;
                      break;
                    }
                    throw error;
                  case 10:
                    // Continue signing out but log the issue.

                    logger.log("Failed to sign out");
                    logger.error(error);
                  case 12:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
          };
          setupEvents = function setupEvents() {
            _state.wallet.on("accountChanged", function (newAccountId) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      logger.log("onAccountChange", newAccountId);
                      emitter.emit("signedOut", null);
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
            });
            _state.wallet.on("rpcChanged", function (rpc) {
              return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      logger.log("onNetworkChange", rpc);
                      if (!(options.network.networkId !== rpc.networkId)) {
                        _context3.next = 6;
                        break;
                      }
                      _context3.next = 4;
                      return signOut();
                    case 4:
                      emitter.emit("signedOut", null);
                      emitter.emit("networkChanged", {
                        networkId: rpc.networkId
                      });
                    case 6:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
            });
          };
          _getAccounts = function getAccounts() {
            return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var accountId;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    accountId = _state.wallet.getAccountId();
                    if (accountId) {
                      _context4.next = 7;
                      break;
                    }
                    _context4.next = 4;
                    return _state.wallet.resolveSignInState();
                  case 4:
                    accountId = _state.wallet.getAccountId();
                    if (accountId) {
                      _context4.next = 7;
                      break;
                    }
                    return _context4.abrupt("return", []);
                  case 7:
                    return _context4.abrupt("return", [{
                      accountId: accountId
                    }]);
                  case 8:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4);
            }));
          };
          isValidActions = function isValidActions(actions) {
            return actions.every(function (x) {
              return x.type === "FunctionCall";
            });
          };
          transformActions = function transformActions(actions) {
            var validActions = isValidActions(actions);
            if (!validActions) {
              throw new Error("Only 'FunctionCall' actions types are supported by ".concat(metadata.name));
            }
            return actions.map(function (x) {
              return x.params;
            });
          };
          transformTransactions = function transformTransactions(transactions) {
            return transactions.map(function (transaction) {
              return {
                receiverId: transaction.receiverId,
                actions: transformActions(transaction.actions)
              };
            });
          };
          if (_state.wallet && _state.wallet.isSignedIn()) {
            setupEvents();
          }
          return _context10.abrupt("return", {
            signIn: function signIn(_ref2) {
              var contractId = _ref2.contractId,
                methodNames = _ref2.methodNames;
              return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var existingAccounts, _yield$_state$wallet$, accessKey, error;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _getAccounts();
                    case 2:
                      existingAccounts = _context5.sent;
                      if (!existingAccounts.length) {
                        _context5.next = 5;
                        break;
                      }
                      return _context5.abrupt("return", existingAccounts);
                    case 5:
                      _context5.next = 7;
                      return _state.wallet.requestSignIn({
                        contractId: contractId,
                        methodNames: methodNames
                      });
                    case 7:
                      _yield$_state$wallet$ = _context5.sent;
                      accessKey = _yield$_state$wallet$.accessKey;
                      error = _yield$_state$wallet$.error;
                      if (!(!accessKey || error)) {
                        _context5.next = 14;
                        break;
                      }
                      _context5.next = 13;
                      return signOut();
                    case 13:
                      throw new Error((typeof error === "string" ? error : error.type) || "Failed to sign in");
                    case 14:
                      setupEvents();
                      _context5.next = 17;
                      return _getAccounts();
                    case 17:
                      return _context5.abrupt("return", _context5.sent);
                    case 18:
                    case "end":
                      return _context5.stop();
                  }
                }, _callee5);
              }));
            },
            signOut: signOut,
            getAccounts: function getAccounts() {
              return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _getAccounts();
                    case 2:
                      return _context6.abrupt("return", _context6.sent);
                    case 3:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
            },
            verifyOwner: function verifyOwner(_ref3) {
              var message = _ref3.message;
              return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      logger.log("NearFi:verifyOwner", {
                        message: message
                      });
                      throw new Error("Method not supported by ".concat(metadata.name));
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
            },
            signAndSendTransaction: function signAndSendTransaction(_ref4) {
              var signerId = _ref4.signerId,
                receiverId = _ref4.receiverId,
                actions = _ref4.actions;
              return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var _store$getState, contract;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      logger.log("signAndSendTransaction", {
                        signerId: signerId,
                        receiverId: receiverId,
                        actions: actions
                      });
                      _store$getState = store.getState(), contract = _store$getState.contract;
                      if (!(!_state.wallet.isSignedIn() || !contract)) {
                        _context8.next = 4;
                        break;
                      }
                      throw new Error("Wallet not signed in");
                    case 4:
                      return _context8.abrupt("return", _state.wallet.signAndSendTransaction({
                        receiverId: receiverId || contract.contractId,
                        actions: transformActions(actions)
                      }).then(function (res) {
                        var _a;
                        if (res.error) {
                          throw new Error(res.error);
                        } // Shouldn't happen but avoids inconsistent responses.

                        if (!((_a = res.response) === null || _a === void 0 ? void 0 : _a.length)) {
                          throw new Error("Invalid response");
                        }
                        return res.response[0];
                      }));
                    case 5:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
            },
            signAndSendTransactions: function signAndSendTransactions(_ref5) {
              var transactions = _ref5.transactions;
              return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      logger.log("signAndSendTransactions", {
                        transactions: transactions
                      });
                      if (_state.wallet.isSignedIn()) {
                        _context9.next = 3;
                        break;
                      }
                      throw new Error("Wallet not signed in");
                    case 3:
                      return _context9.abrupt("return", _state.wallet.requestSignTransactions({
                        transactions: transformTransactions(transactions)
                      }).then(function (res) {
                        var _a;
                        if (res.error) {
                          throw new Error(res.error);
                        } // Shouldn't happen but avoids inconsistent responses.

                        if (!((_a = res.response) === null || _a === void 0 ? void 0 : _a.length)) {
                          throw new Error("Invalid response");
                        }
                        return res.response;
                      }));
                    case 4:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
            }
          });
        case 9:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
};
function setupNearFi() {
  var _this = this;
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$iconUrl = _ref6.iconUrl,
    iconUrl = _ref6$iconUrl === void 0 ? icon : _ref6$iconUrl,
    _ref6$deprecated = _ref6.deprecated,
    deprecated = _ref6$deprecated === void 0 ? false : _ref6$deprecated;
  return function () {
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var mobile, installed;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            mobile = isMobile();
            _context11.next = 3;
            return isInstalled();
          case 3:
            installed = _context11.sent;
            if (!(!mobile || !installed)) {
              _context11.next = 6;
              break;
            }
            return _context11.abrupt("return", null);
          case 6:
            return _context11.abrupt("return", {
              id: "nearfi",
              type: "injected",
              metadata: {
                name: "NearFi",
                description: "Your NEAR DeFi experience On The Go",
                iconUrl: iconUrl,
                downloadUrl: "https://nearfi.finance",
                deprecated: deprecated,
                available: installed
              },
              init: NearFi
            });
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
  };
}
export { setupNearFi };